const recommendedRoutesS1 = [
  "v3/properties", // all like getting properties in listing , single property details , property room availability
  "v3/bookings", // all routes related to this like validate , complete
  "v3/public/log-error",

  "v3/listing/destinations",
];

export const recommendedRoutesS2 = ["available-properties"];

export default recommendedRoutesS1;
